import HeroSlider from './heroSlider/heroSlider.component';
import Category from './category/category.component';
import Feature from './feature/feature.component';
import CTA from './cta/cta.component';
import ScrollRestoration from './scrollRestoration/scrollRestoration.component';
import QrCodeImage from './qrCodeImage/qrCodeImage.component';
import ScrollToTop from "./scrollToTop/scrollToTop.component";
import HomeEventsSection from "./homeEventsSection/homeEventsSection.component";
import {
    FeatureSection,
    MetricsSection,
    Testimonials,
    SecondaryCTA,
    EventsSection,
    IndustriesSection,
    ComparisonSection,
    PrimaryCTA,
    HeroSection,
    ProblemSection,
} from "./landing";

export {
    HeroSlider,
    Category,
    Feature,
    HomeEventsSection,
    CTA,
    ScrollRestoration,
    QrCodeImage,
    ScrollToTop,
    EventsSection,
    HeroSection,
    FeatureSection,
    MetricsSection,
    Testimonials,
    SecondaryCTA,
    IndustriesSection,
    ComparisonSection,
    PrimaryCTA,
    ProblemSection
};
